/**
 * True when the person dismissed the device's own passkey prompt (Face ID,
 * fingerprint, Windows Hello) instead of completing it. That is a choice, not
 * a failure, so callers should show nothing for it.
 */
export function isUserCancelled(error: unknown): boolean {
  return (error as { name?: string } | null)?.name === 'NotAllowedError'
}
